<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{modalTitle}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="row">

      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
        <div *ngFor="let validation of msg">
          <div class="error-message"
            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
            {{validation.message}}
          </div>
        </div>
      </ng-template>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang.projectClass }}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="text" class="form-control" formControlName="class"
            [ngClass]="formErrorClass(createForm.controls.class, createFormSubmitted)">


          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.class, value:createForm.controls.class, submitted:createFormSubmitted }">
          </ng-template>
        </div>
      </div>



      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang.projectCategory }}</label>
        </div>
        <div class="form-group col-sm-9">

          <input type="text" class="form-control" formControlName="category"
            [ngClass]="formErrorClass(createForm.controls.category, createFormSubmitted)">

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.category, value:createForm.controls.category, submitted:createFormSubmitted }">
          </ng-template>
        </div>

      </div>



      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang.description }}</label>
        </div>
        <div class="form-group col-sm-9">

          <textarea class="form-control" formControlName="description"
            [ngClass]="formErrorClass(createForm.controls.description, createFormSubmitted)"></textarea>

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.description, value:createForm.controls.description, submitted:createFormSubmitted }">
          </ng-template>

        </div>
      </div>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang.periodicRepetition }}</label>
        </div>
        <div class="form-group col-sm-9">
          <label class="checkbox-inline checkbox-custom-alt">
            <input type="radio" formControlName="repetition_option" value="1"
              [ngClass]="formErrorClass (createForm.controls.repetition_option, createFormSubmitted)"
              (click)="show_child(1)"><i></i> {{ generalLang.yes }}
          </label>
          <label class="checkbox-inline checkbox-custom-alt">
            <input type="radio" formControlName="repetition_option" value="0"
              [ngClass]="formErrorClass (createForm.controls.repetition_option, createFormSubmitted)"
              (click)="show_child(0)"><i></i>
            {{ generalLang.nos}}
          </label>
        </div>
      </div>

      <div class="reptition_child" style="display: none;">
        <div class="form-group col-sm-12">
          <div class="form-group col-sm-3">
            <label>{{ generalLang.repetations }}</label>
          </div>
          <div class="form-group col-sm-4" style="width: 35%;">

            <input type="text" class="form-control" formControlName="repetitions_count"
              [ngClass]="formErrorClass(createForm.controls.repetitions_count, createFormSubmitted)" maxlength="4"
              pattern="[0-9]+" ng-pattern-restrict>

            <!-- <span *ngIf="createFormSubmitted && createForm.controls['repetitions_count'].valid" style="color: #ff7b76;">This field is Required</span> -->

            <ng-template [ngTemplateOutlet]="ErrorMsg"
              [ngTemplateOutletContext]="{msg:createFormErrorMsg.repetitions_count, value:createForm.controls.repetitions_count, submitted:createFormSubmitted }">
            </ng-template>

          </div>



          <div class="form-group col-sm-4" style="width: 35%;">
            <select class="form-control" formControlName="repetitions_type"
              [ngClass]="formErrorClass(createForm.controls.repetitions_type, createFormSubmitted)">
              <option value="">{{ generalLang.select }}</option>
              <option *ngFor="let type of frequencyConfig" [ngValue]="type.value">{{type.text}}</option>
            </select>

            <!-- <span *ngIf="createFormSubmitted && createForm.hasError('range_empty2')"
              style="color: #ff7b76;">This field is Required</span> -->

            <ng-template [ngTemplateOutlet]="ErrorMsg"
              [ngTemplateOutletContext]="{msg:createFormErrorMsg.repetitions_count, value:createForm.controls.repetitions_count, submitted:createFormSubmitted }">
            </ng-template>


          </div>
        </div>


        <div class="form-group col-sm-12">
          <div class="form-group col-sm-3">
            <label>{{ generalLang.daysnotify }}</label>
          </div>
          <div class="form-group col-sm-9">
            <input type="text" class="form-control" formControlName="days_notify"
              [ngClass]="formErrorClass(createForm.controls.days_notify, createFormSubmitted)" maxlength="4"
              pattern="[0-9]+" ng-pattern-restrict>

            <ng-template [ngTemplateOutlet]="ErrorMsg"
              [ngTemplateOutletContext]="{msg:createFormErrorMsg.days_notify, value:createForm.controls.days_notify, submitted:createFormSubmitted }">
            </ng-template>

            <!-- <span *ngIf="createFormSubmitted && createForm.hasError('range_empty3')"
          style="color: #ff7b76;">This field is Required</span> -->


            <div *ngIf="createForm.controls.days_notify.touched && createForm.hasError('rangeval')" style="color: red;">
              Days notify should be less than the repetition.</div>
          </div>
        </div>


        <div class="form-group col-sm-12">

          <div class="form-group col-sm-3">
            <label>{{ generalLang.notificationTime }}</label>
          </div>
          <div class="form-group col-sm-9">

            <select class="form-control" formControlName="notify_time"
              [ngClass]="formErrorClass(createForm.controls.notify_time, createFormSubmitted)">
              <option value="">{{ generalLang.selectTime }}</option>
              <option *ngFor="let mplan of this.notification_time" [ngValue]="mplan">{{mplan}}</option>
            </select>


            <!-- <span *ngIf="createFormSubmitted && createForm.hasError('range_empty4')"
            style="color: #ff7b76;">This field is Required</span> -->



            <ng-template [ngTemplateOutlet]="ErrorMsg"
              [ngTemplateOutletContext]="{msg:createFormErrorMsg.notify_time, value:createForm.controls.notify_time, submitted:createFormSubmitted }">
            </ng-template>




          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-success">{{ generalLang.save }}</button>
    <!-- <button class="btn btn-warning" data-dismiss="modal" (click)="bsModalRef.hide()">Close</button> -->
    <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">{{ generalLang.close }}</button>

  </div>
</form>

<ng-template #imagePreviewRef let-link='imageLink'>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Image Preview</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body section-spaces">
    <app-image-preview [imageUrl]="imageLink"></app-image-preview>
  </div>
</ng-template>